export function HostRoutes($stateProvider: ng.ui.IStateProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider) {
  $stateProvider
    // go to `#/my/fp`
    //
    //
    .state('my.fp', {
      abstract: true,
      templateUrl: 'lib/host/views/nav-fp-micro/nav-fp-micro.html'
    })
    .state('my.fp.active', {
      url: 'fp/{path:.*}',
      data: {
        viewTitle: 'Financial Planner | Navigate360'
      }
    })
    .state('my.surveys', {
      abstract: true,
      templateUrl: 'lib/host/views/nav-survey-home-micro/nav-survey-home-micro.html'
    })
    .state('my.surveys.list', {
      url: 'survey-home/{path:.*}'
    })
    .state('my.host', {
      abstract: true,
      templateUrl: 'lib/host/views/nav-host/nav-host.html'
    })
    .state('my.host.active', {
      url: 'host/{path:.*}'
    })
    .state('my.calendar', {
      abstract: true,
      templateUrl: 'lib/host/views/nav-calendar/nav-calendar.html'
    })
    .state('my.calendar.active', {
      url: 'calendar/{path:.*}'
    })
    .state('my.journeys.active', {
      url: 'journeys/{path:.*}'
    });
}



// WEBPACK FOOTER //
// ./app/lib/host/host_routes.ts